import * as React from "react";
import {translate} from "react-i18next";
import * as _ from "lodash";
import {connect, Dispatch} from "react-redux";
// reducer
import {RouteComponentProps} from "react-router-dom";
import {ITranslatedComponent, ITypefamilyMap} from "../../redux/reducers/generalReducer";
import {compose} from "redux";
import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import GeneralActions from "../../redux/actions/GeneralActions";
import {IReduxState} from "src/redux/IReduxState";
import {
    selectAdminArealinks,
    selectBaseLinks,
    selectClient,
    selectKumaExtraLinks,
    selectLanguage,
    selectLanguageList,
    selectSwitchHeaderMode,
    selectTypefamilyMap,
    selectUserCnrs,
    selectUserInfo,
    selectUserPSLModelyears,
    selectUserRoles,
    selectWorkflows
} from "../../redux/selectors";
import ColumnFactory from "../../services/ColumnFactory";
import ErrorBoundary from "../../utils/ErrorBoundary";

import ViewContainer from "../ViewContainer";
import {AgGridReact} from "ag-grid-react";

import {getColumnDefs, getDefaultColDef} from "./KumaBasicColumns";
import ModeltypeHeader from "../ModeltypeBasicView/ModeltypeHeader";
import {VIEWNAME} from "../../utils/GeneralUtils";
import HATEOASClient, {GetNewRequirementListParams} from "../../services/HATEOASClient";
import DataAdapterKumaView from "./DataAdapterKumaView";
import NewKumaViewDialog from "./NewKumaViewDialog";
import {
    CnrDto,
    KumaCnrByRegionParams,
    KumaRegionListDto,
    KumaRequirementListDto,
    KumaViewDto,
    LanguageDto,
    Link,
    MenuDto,
    ModeltypeBasicDto,
    ResourceListOfModelyearDto,
    ResourceListOfTypefamilyDto,
    RoleDto,
    UserDto,
    VoteDto,
    WorkflowDto
} from "../../services/Client";
import {renderErrorToast} from "src/utils/FeedbackMessageUtils";
import KumaViewActions from "src/redux/actions/KumaViewActions";
import {getKumaRequirementTotalVotes, KUMA_COL_RESIZE, onColumnResized, PAGE_SIZE} from "./utils";
import {KumaDeleteConfirmDialog} from "./KumaDeleteConfirmDialog";
import {Button, Input, Tab, TabProps} from "semantic-ui-react";
import {createRowsFromResourceList} from "../BaseOptionsView/BaseOptionsRowUtils";
import {createRowsForKumaRequirement} from "./KumaRowUtils";
import {getDtoStatus, valueState2str} from "src/services/WorkflowUtils";
import AdminViewActions from "src/redux/actions/AdminViewActions";

const createLinkName = (value: number, state: any): ITextAndIcon => {
    const {userModelyears} = state.general;
    const mj = userModelyears.elements ? userModelyears.elements.find((mjo: any) => mjo.objectId === value) : undefined;
    const sval = !mj ? value : ColumnFactory.mj2str(mj);
    return {text: "MODELYEAR_VALUE", options: {value: sval}, noTranslation: false};
};
interface IMapDispatchToProps {
    addTranslationLocation: (translation: ILocationTranslation) => void;
    ReceiveKumaExtraLinksAction: (extraLinks: any) => void;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    getWorkflows: () => void;
    ReceivedKumaRequirementsAction: (requirements: KumaViewDto[]) => void;
}
interface IMapStateToProps {
    userLanguage: string;
    client: HATEOASClient;
    switchHeaderMode: boolean;
    typefamilyMap?: ITypefamilyMap;
    baseLinks?: MenuDto;
    kumaExtraLinks?: MenuDto;
    userCnrs: CnrDto[];
    userInfos: UserDto | undefined;
    userPSLModelyears: ResourceListOfModelyearDto;
    languageList?: LanguageDto[];
    workflows?: WorkflowDto[];
    roles?: RoleDto[];
    adminAreaLinks?: MenuDto;
}

interface IOwnProps {
}

interface IKumaBasicViewProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent, RouteComponentProps<RouteProps> {
}

interface RouteProps {
    modelyear?: string;
}

interface IKumaBasicViewState {
    requirements: Array<any>;
    /** shows the dialog to create new modeltype */
    isShowNewKumaDialog: boolean;

    /** currently selected item */
    selectedItem?: DataAdapterKumaView;
    createNewRequirementLink: MenuDto;
    gridApi: any;
    /** Whether or not to show the dialog for deleting multiple options */
    showMultipleDeleteOptionDlg: boolean;
    selectedItems: Array<any>;
    quickFilterText: string;
    /** currently selected tab */
    activeTab: number | string;
    regions: KumaRegionListDto;
    typefamilies: ResourceListOfTypefamilyDto;
    kumaKefagList: string[];
    users: Array<UserDto>;
    userCnrs: CnrDto[];
    derivates: ModeltypeBasicDto[];
}

class KumaBasicView extends React.Component<IKumaBasicViewProps, IKumaBasicViewState> {

    /** message if modifiing */
    modifiingMessage?: string;

    constructor(props: IKumaBasicViewProps) {
        super(props);

        this.state = {
            requirements: [],
            isShowNewKumaDialog: false,
            createNewRequirementLink: {},
            gridApi: {},
            showMultipleDeleteOptionDlg: false,
            selectedItems: [],
            quickFilterText: '',
            activeTab: 0,
            regions: {},
            typefamilies: {},
            kumaKefagList: [],
            users: [],
            userCnrs: [],
            derivates: []
        };
    }

    componentDidMount() {
        // add translation of the link address
        this.props.addTranslationLocation({pattern: "kuma", substitutes: "KUMA_VIEW"});
        if (this.props.workflows === undefined) {
            this.props.getWorkflows();
        } else {
            this.reloadData();
        }
    }
    componentDidUpdate(prevProps: Readonly<IKumaBasicViewProps>) {
        // Check if workflows and languageList are both available, and only then call reloadData
        const workflowsLoaded = this.props.workflows && this.props.workflows.length > 0;
        const languageListLoaded = this.props.languageList && this.props.languageList.length > 0;

        if (workflowsLoaded && languageListLoaded) {
            const prevWorkflowsLoaded = prevProps.workflows && prevProps.workflows.length > 0;
            const prevLanguageListLoaded = prevProps.languageList && prevProps.languageList.length > 0;

            if (!prevWorkflowsLoaded || !prevLanguageListLoaded) {
                this.reloadData();
            }
        }
    }
    private setModifiing = (val?: string) => {
        if (val) {
            this.props.addLoadingMessage(val);
            this.modifiingMessage = val;
        }
        else if (this.modifiingMessage) {
            this.props.removeLoadingMessage(this.modifiingMessage);
            this.modifiingMessage = undefined;
        }
    }
    private reloadData = () => {

        if (this.props.baseLinks) {
            this.requestKumaExtraLinks(this.props.baseLinks);
        }

    }
    private async loadData() {
        const {client, t} = this.props;
        if (this.props.kumaExtraLinks) {
            const regions = await client.GET_kumaRegionList(this.props.kumaExtraLinks).execute();
            const kumaTypeFamilies = await client.GET_kumaTypefamilyList(this.props.kumaExtraLinks).execute();
            const kefag = await client.GET_architectureSystemList(this.props.kumaExtraLinks).execute();
            const params: KumaCnrByRegionParams = {
                regionIds: [1, 2, 3, 4, 5]
            };
            const markets = await client.GET_kumaCnrList(this.props.kumaExtraLinks).execute(params);

            if (markets.elements) {
                markets.elements.unshift({
                    objectId: 0,
                    name: t("KUMA_VIEW:ALL_MARKETS"),
                    versionId: 0,
                    cnr: t("KUMA_VIEW:ALL_MARKETS")
                });
                this.setState({userCnrs: markets.elements});
            }
            if (regions.elements) {
                regions.elements.unshift({
                    objectId: 0,
                    name: t("KUMA_VIEW:ALL_REGIONS"),
                    versionId: 0,
                    id: 0
                });
            }
            if (kumaTypeFamilies.elements) {
                kumaTypeFamilies.elements = kumaTypeFamilies.elements.map((element: any) => ({
                    ...element,
                    key: element.typefamily === 'M' ? 'M_TYPEFAMILY' : element.typefamily, // Add key property
                }));
            }
            this.setState({regions, typefamilies: kumaTypeFamilies, kumaKefagList: kefag});
        }
    }
    /**
     * Loads the KUMA derivates. The required "GET_kuma_dertivates" link lives inside the
     * requirement list response (stored in createNewRequirementLink), so this must only be
     * called once that link container is populated. The canExecute() guard prevents the
     * "Failed to find required property links" error when the link is not (yet) available.
     */
    private loadDerivates = async (linkContainer: MenuDto) => {
        const {client} = this.props;
        if (client.GET_kuma_dertivates(linkContainer).canExecute()) {
            const derivates = await client.GET_kuma_dertivates(linkContainer).execute();
            this.setState({derivates: derivates.elements || []});
        }
    }
    private async requestAdminAreaLinks(baseLinks: MenuDto) {
        if (!this.props.client.GET_adminArea(baseLinks).canExecute()) {
            return;
        }
        const adminAreaLinks = await this.props.client.GET_adminArea(baseLinks).execute();
        const roleRes = await this.props.client.GET_roleList(adminAreaLinks).execute();
        const usersRes = await this.props.client.GET_userList(adminAreaLinks).execute();
        if (usersRes.elements && roleRes.elements) {
            const assginedRoleUsers = usersRes.elements.filter((p: UserDto) => p.assignedRoles && p.assignedRoles.length > 0);
            const kumaAssignedRole = roleRes.elements.filter((p: RoleDto) => p.privileges && p.privileges.map((q: any) => q.identifier).includes("KUMA_WRITE"));
            const permittedUsers = assginedRoleUsers
                .filter((p: UserDto) => p.assignedRoles && p.assignedRoles.map((q: any) => q.role)
                    .some((r: RoleDto) => kumaAssignedRole.map((s: RoleDto) => s.objectId).includes(r.objectId)));
            this.setState({users: permittedUsers});
        }
    }
    requestKumaExtraLinks = (baseLinks: MenuDto) => {
        if (this.props.client.GET_kumaExtraLinks(baseLinks).canExecute()) {
            this.props.client.GET_kumaExtraLinks(baseLinks).execute()
                .then((extraLinks: MenuDto) => {
                    this.props.ReceiveKumaExtraLinksAction(extraLinks);
                    this.requestRequirementList(extraLinks);
                    this.loadData();
                    if (this.props.baseLinks) {
                        this.requestAdminAreaLinks(this.props.baseLinks);
                    }
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }
    requestRequirementList = (extraLinks: MenuDto | undefined) => {
        if (extraLinks) {
            if (this.props.client.GET_kumaRequirementList(extraLinks).canExecute()) {
                const params: GetNewRequirementListParams = {
                    metadata: true,
                };
                this.props.client.GET_kumaRequirementList(extraLinks).execute(params)
                    .then((data: KumaRequirementListDto) => {
                        const {languageList, workflows} = this.props;
                        if (data.elements && languageList && workflows) {
                            const rows = createRowsForKumaRequirement(data, languageList, workflows);
                            const sortedData = rows.sort((a: any, b: any) => {
                                const aVotes = getKumaRequirementTotalVotes(a.votes);
                                const bVotes = getKumaRequirementTotalVotes(b.votes);
                                if (aVotes !== bVotes) {
                                    return bVotes - aVotes;
                                }
                                return b.objectId - a.objectId;
                            });
                            this.setState({requirements: sortedData, createNewRequirementLink: {links: data.links} as MenuDto});
                            this.props.ReceivedKumaRequirementsAction(sortedData);
                            this.loadDerivates({links: data.links} as MenuDto);
                        }

                    })
                    .catch((reason: any) => {
                        window.scrollTo(0, 0);
                        renderErrorToast({
                            message: "ERRORS:GET_KUMA_LIST",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        }
    }

    setActiveInactiveRequirements = (dtos: any) => {
        const loadingMsg = this.state.activeTab === 0 ? this.props.t("KUMA_SET_INACTIVE") : this.props.t("KUMA_SET_ACTIVE");
        this.props.addLoadingMessage(loadingMsg);
        this.patchActiveInActiveKumaRequirement(dtos, loadingMsg);
    }
    patchActiveInActiveKumaRequirement = (newRow: KumaViewDto[], loadingMsg: string) => {
        const {createNewRequirementLink} = this.state;
        if (this.props.client.PATCH_kumaRequirement(createNewRequirementLink).canExecute()) {
            this.props.client.PATCH_kumaRequirement(createNewRequirementLink).execute(newRow)
                .then(() => {
                    this.props.removeLoadingMessage(loadingMsg);
                    this.requestRequirementList(this.props.kumaExtraLinks);
                    this.setState({selectedItems: []});
                })
                .catch((reason: any) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_LIST",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }
    patchKumaRequirement = (newRow: KumaViewDto, loadingMsg: string) => {
        const {createNewRequirementLink} = this.state;
        if (this.props.client.PATCH_kuma_requirement_update(createNewRequirementLink).canExecute()) {
            this.props.client.PATCH_kuma_requirement_update(createNewRequirementLink).execute(newRow)
                .then(() => {
                    this.props.removeLoadingMessage(loadingMsg);
                    this.requestRequirementList(this.props.kumaExtraLinks);
                    this.setState({selectedItems: []});
                })
                .catch((reason: any) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    renderErrorToast({
                        message: "ERRORS:PATCH_kuma_requirement_update",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    deleteKumaRequirements = (): void => {
        const {createNewRequirementLink} = this.state;
        const dtos = this.state.selectedItems.map((item) => {
            delete item.metadata;
            return item;
        });
        const loadingMsg = this.props.t("DELETE_REQUIREMENT");
        if (this.props.client.DELETE_kumaRequirementList(createNewRequirementLink).canExecute()) {
            this.props.client.DELETE_kumaRequirementList(createNewRequirementLink).execute(dtos)
                .then(() => {
                    this.props.removeLoadingMessage(loadingMsg);
                    this.requestRequirementList(this.props.kumaExtraLinks);
                    this.setState({selectedItems: []});
                })
                .catch((reason: any) => {
                    this.props.removeLoadingMessage(loadingMsg);
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_LIST",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    onWorkFlowUpdate = (newRow: KumaViewDto) => {
        if (this.props.workflows) {
            newRow.statusView = valueState2str(newRow.statusValueState, this.props.workflows);
            newRow.status = newRow.statusValueState !== undefined ? getDtoStatus(newRow.statusValueState, newRow.status, this.props.workflows) : "";
            const {createNewRequirementLink} = this.state;
            const {client} = this.props;
            if (client.PATCH_kumaRequirement_change_workflow_status(createNewRequirementLink).canExecute()) {
                client.PATCH_kumaRequirement_change_workflow_status(createNewRequirementLink).execute(newRow)
                    .then((date) => {
                        this.requestRequirementList(this.props.kumaExtraLinks);
                    })
                    .catch((reason: any) => {
                        renderErrorToast({
                            message: "ERRORS:PATCH_kumaRequirement_change_workflow_status",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            }
        }

    }

    private onGridReady = (params: any) => {
        this.setState({gridApi: params.api});
    }
    private onQuickFilterChange = (event: any) => {
        const {value} = event.target;
        this.setState({quickFilterText: value});
        this.state.gridApi.setQuickFilter(value);
    }
    private handleRate = (requirementId: number, stars: number) => {
        const {createNewRequirementLink} = this.state;
        const {client} = this.props;
        if (client.POST_kumaRequirementVote(createNewRequirementLink).canExecute()) {
            const voteDto: VoteDto = {
                requirementId,
                stars
            };
            client.POST_kumaRequirementVote(createNewRequirementLink).execute(voteDto)
                .then((date) => {
                    this.requestRequirementList(this.props.kumaExtraLinks);
                })
                .catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_LIST",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }

    }
    private renderKumaGrid = (activeTab: number | string) => {

        let rowData = this.state.requirements.filter(p => p.active);
        if (activeTab === 1) {
            rowData = this.state.requirements.filter(p => !p.active);
        }

        const {userInfos} = this.props;

        return (
            <>
                <div>
                    <Input value={this.state.quickFilterText} placeholder='Quick search...' icon="search" className="search" onChange={this.onQuickFilterChange} />
                </div>
                <div style={{height: '100%'}} data-cy="kuma_grid">
                    <div className="ag-theme-alpine" style={{height: 'calc(85vh)'}}>
                        <AgGridReact
                            onGridReady={this.onGridReady}
                            rowData={rowData}
                            rowModelType={'clientSide'}
                            columnDefs={
                                getColumnDefs(
                                    this.props.t,
                                    this.state.activeTab,
                                    this.handleRate,
                                    userInfos ? userInfos.cn : '',
                                    this.onWorkFlowUpdate,
                                    this.props.roles,
                                    {
                                        isEdit: this.hasKumaWritePrivilege(),
                                        kumaExtraLinks: this.props.kumaExtraLinks,
                                        client: this.props.client,
                                        onRowUpdate: this.onRowUpdate,
                                        userPSLModelyears: this.props.userPSLModelyears.elements,
                                        typefamilies: this.state.typefamilies.elements,
                                        kumaKefagList: this.state.kumaKefagList,
                                        api: this.state.gridApi,
                                        users: this.state.users,
                                        addLoadingMessage: this.props.addLoadingMessage,
                                        removeLoadingMessage: this.props.removeLoadingMessage,
                                        rowData: rowData,
                                        regions: this.state.regions.elements,
                                        userCnrs: this.state.userCnrs,
                                        createNewRequirementLink: this.state.createNewRequirementLink,
                                    })
                            }
                            defaultColDef={getDefaultColDef}
                            suppressRowClickSelection={true}
                            groupSelectsChildren={true}
                            rowSelection={'multiple'}
                            rowGroupPanelShow={'always'}
                            pivotPanelShow={'always'}
                            pagination={true}
                            rowHeight={170}
                            paginationPageSize={PAGE_SIZE}
                            cacheBlockSize={PAGE_SIZE}
                            domLayout='normal'
                            rowClass={activeTab === 1 ? 'disabled_row' : ''}
                            onColumnResized={(event) => onColumnResized(event, KUMA_COL_RESIZE)}
                            onSelectionChanged={(event) => {
                                this.setState({selectedItems: event.api.getSelectedRows()});
                            }}
                            onCellEditingStopped={(event: any) => {
                                if (event.column.colId === 'assignedCnrs' || event.column.colId === 'regions' || event.column.colId === 'derivates') {
                                    return;
                                } else {
                                    let payload;
                                    if (event.newValue) {
                                        payload = {[event.column.colId]: event.newValue, objectId: event.data.objectId};
                                    } else {
                                        if (event.column.colId === 'architectureSystems') {
                                            payload = {architectureSystems: event.data.architectureSystems, objectId: event.data.objectId};
                                        } else {
                                            payload = {[event.column.colId]: event.data[event.column.colId], objectId: event.data.objectId};
                                        }
                                    }
                                    this.onRowUpdate(payload);
                                }

                            }}
                        />
                    </div>
                </div>
            </>

        );
    }
    private renderNewRequirementTable = () => {
        const {history} = this.props;
        return (
            <div className="quick_filter">
                <div className="tab">
                    <div className="right">
                        <Button icon={"dashboard"} className='table-header-button' onClick={() => history.push('/kuma/managementview')} />
                    </div>
                    <Tab
                        menu={{attached: true, tabular: true}}
                        onTabChange={(event: React.MouseEvent<HTMLDivElement>, data: TabProps) => this.setState({
                            activeTab: data.activeIndex ? data.activeIndex : 0,
                            selectedItems: []
                        })}
                        panes={[
                            {
                                menuItem: this.props.t("KUMA_ACTIVE_TAB"),
                                render: () => (
                                    <Tab.Pane attached={false}>
                                        {this.renderKumaGrid(this.state.activeTab)}
                                    </Tab.Pane>
                                )
                            },
                            {
                                menuItem: this.props.t("KUMA_INACTIVE_TAB"),
                                render: () => (
                                    <Tab.Pane attached={false}>
                                        {this.renderKumaGrid(this.state.activeTab)}
                                    </Tab.Pane>
                                )
                            },
                        ]}
                    />
                </div>
            </div>

        );
    }

    private onClickDeleteButton = () => {
        this.setState({showMultipleDeleteOptionDlg: true});
    }
    private onRowUpdate = (newRow: any) => {
        this.props.addLoadingMessage(this.props.t("UPDATING_REQUIREMENT"));
        this.patchKumaRequirement(newRow, this.props.t("UPDATING_REQUIREMENT"));
    }
    private onClickActiveDeactiveButton = () => {
        let dtos;
        if (this.state.activeTab === 0) {
            dtos = this.state.selectedItems.map((item) => {
                delete item.metadata;
                return item;
            });
        } else {
            dtos = this.state.selectedItems.map((item) => {
                delete item.metadata;
                item.active = false;
                return item;
            });
        }
        this.setActiveInactiveRequirements(dtos);
    }

    private renderHeader = () => {
        const inEditMode = false;
        const deleteable = true;
        const updatable = false;
        const hasSelectedItem = this.state.selectedItems && this.state.selectedItems.length > 0;
        const modeltypeBasicList = [];
        const hasCopyYear = false;
        let hasPostKUMALink = this.hasKumaWritePrivilege();
        // tslint:disable-next-line:no-shadowed-variable
        const {t, switchHeaderMode, client} = this.props;
        return (
            <ModeltypeHeader
                viewName={VIEWNAME.KUMAVIEW}
                inEditMode={inEditMode}
                switchHeaderMode={switchHeaderMode}
                hasReloadButton={true}
                isSelected={true}
                hasNewButton={hasPostKUMALink}
                hasCopyButton={hasPostKUMALink && !!hasSelectedItem}
                hasDeleteButton={deleteable}
                hasEditButton={updatable}
                hasCopyYearButton={hasCopyYear}
                hasHistoryButton={modeltypeBasicList.length > 0}

                disabledNewButton={inEditMode || !hasPostKUMALink}
                disabledCopyButton={inEditMode || !hasPostKUMALink}
                disabledDeleteButton={!hasSelectedItem
                    || !hasPostKUMALink
                    || this.state.activeTab === 0} // selectedItem && !client.DELETE_modeltypeBasic(selectedItem.value).canExecute()
                disabledReloadButton={inEditMode}
                disableHistoryButton={inEditMode || !hasSelectedItem}
                iconNewButton={"add"}
                labelNewButton={t("NEW_REQUIREMENT")}
                labelCopyButton={t("COPY_DERIVATE")}
                labelDeleteButton={t("DELETE_REQUIREMENT")}
                labelActiveInactiveButton={this.state.activeTab === 0 ? t("KUMA_SET_INACTIVE") : t("KUMA_SET_ACTIVE")}
                labelEditButton={!inEditMode ? t("START_EDITING") : t("STOP_EDITING")}
                labelReloadButton={t("RELOAD")}
                labelCopyYearButton={t("COPY_DERIVATES")}
                labelHistoryButton={t("SHOW_DERIVATE_HISTORY")}

                onClickNewButton={() => this.setState({isShowNewKumaDialog: true})}
                onClickCopyButton={() => this.setState({isShowNewKumaDialog: true})}
                onClickDeleteButton={this.onClickDeleteButton}
                onClickActiveDeactiveButton={this.onClickActiveDeactiveButton}
                onClickEditButton={() => {console.log('need to implement');}}
                onClickReloadButton={() => {this.requestRequirementList(this.props.kumaExtraLinks);}}
                onClickHistoryButton={() => {console.log('need to implement');}}
                btnActiveDeactiveIcon={this.state.activeTab === 0 ? 'eraser' : 'recycle'}
                disabledActiveInactiveButton={!hasSelectedItem || !hasPostKUMALink}

            />
        );
    }
    private hasKumaWritePrivilege = () => {
        const {createNewRequirementLink} = this.state;
        if (createNewRequirementLink) {
            return createNewRequirementLink && this.props.client.POST_kumaRequirement(createNewRequirementLink).canExecute();
        }
        return false;
    }

    private handleNewModeltype = (newItem: DataAdapterKumaView) => {
        const {createNewRequirementLink} = this.state;
        const {t, client, kumaExtraLinks} = this.props;
        if (createNewRequirementLink) {
            const newValue = newItem.value;
            newValue.typefamilies = newValue.typefamilies.map((p: any) => p.selectedValue);
            newValue.modelyears = newValue.modelyears ? newValue.modelyears.map((q: any) => q.selectedValue) : [];
            newValue.derivates = newValue.derivates ? newValue.derivates.map((q: any) => q.selectedValue) : [];
            newValue.active = true;
            newValue.votes = [];
            const params =
            {
                title: newValue.title
            };

            this.setModifiing(t("CREATING_NEW_REQUIREMENT", params));
            client.POST_kumaRequirement(createNewRequirementLink).execute(newValue)
                .then(async (link: Link) => {
                    if (kumaExtraLinks) {
                        this.requestRequirementList(kumaExtraLinks);
                        this.setState({
                            isShowNewKumaDialog: false,
                        });
                        this.setModifiing();
                    }
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    this.setModifiing();
                    renderErrorToast({
                        message: "ERRORS:GET_KUMA_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private showNewKumaViewDialog = () => {
        return (
            <NewKumaViewDialog
                templateItem={this.state.selectedItem}
                onCreateNewModeltype={this.handleNewModeltype}
                onCancel={() => this.setState({isShowNewKumaDialog: false})}
                kumaExtraLinks={this.props.kumaExtraLinks}
                client={this.props.client}
                userPSLModelyears={this.props.userPSLModelyears}
                addLoadingMessage={this.props.addLoadingMessage}
                removeLoadingMessage={this.props.removeLoadingMessage}
                regions={this.state.regions}
                typefamilies={this.state.typefamilies}
                kumaKefagList={this.state.kumaKefagList}
                userCnrs={this.state.userCnrs}
                derivates={this.state.derivates}

            />
        );
    }

    private renderMultipleOptionDeletionDlg = (): JSX.Element => {
        return (
            <KumaDeleteConfirmDialog
                canDeleteDtos={this.state.selectedItems}

                onConfirm={() => {
                    this.deleteKumaRequirements();
                    this.setState({
                        showMultipleDeleteOptionDlg: false
                    });
                }}
                onCancel={() => this.setState({
                    showMultipleDeleteOptionDlg: false
                })}
            />
        );
    }

    render() {
        const {isShowNewKumaDialog, showMultipleDeleteOptionDlg, selectedItems} = this.state;
        return (
            <ViewContainer>
                <ErrorBoundary >
                    {
                        this.renderHeader()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        this.renderNewRequirementTable()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        isShowNewKumaDialog &&
                        this.showNewKumaViewDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showMultipleDeleteOptionDlg && selectedItems.length > 0 &&
                        this.renderMultipleOptionDeletionDlg()
                    }
                </ErrorBoundary>
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    switchHeaderMode: selectSwitchHeaderMode(state),
    userLanguage: selectLanguage(state),
    client: selectClient(state),
    typefamilyMap: selectTypefamilyMap(state),
    baseLinks: selectBaseLinks(state),
    kumaExtraLinks: selectKumaExtraLinks(state),
    userCnrs: selectUserCnrs(state),
    userInfos: selectUserInfo(state),
    userPSLModelyears: selectUserPSLModelyears(state),
    languageList: selectLanguageList(state),
    workflows: selectWorkflows(state),
    roles: selectUserRoles(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: IKumaBasicViewProps): IMapDispatchToProps => ({
    addTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({pattern: "kuma", substitutes: "KUMA"})),
    ReceiveKumaExtraLinksAction: (extraLinks) => dispatch(KumaViewActions.ReceiveKumaExtraLinksAction(extraLinks)),
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    getWorkflows: () => dispatch(GeneralActions.GetWorkflows(ownProps.t)),
    ReceivedKumaRequirementsAction: (requirements) => dispatch(KumaViewActions.ReceivedKumaRequirementsAction(requirements))

});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["KUMA_VIEW", "HISTORY", "WORKFLOW"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(KumaBasicView);



// WEBPACK FOOTER //
// ./src/views/KumaView/KumaBasicView.tsx